import { needsStyledComponents } from "@sproutsocial/seeds-react-system-props";
import { PanelStyled } from "./PanelStyled";
import { PanelTailwind } from "./PanelTailwind";
import type { TypePanelProps } from "./PanelTypes";

/**
 * Hybrid Panel router. Chooses the styled-components path when the consumer
 * passes a styled-system (`COMMON`) prop or a `styled()` extension, otherwise
 * the preferred Tailwind path.
 *
 * The routing decision runs on the *leftover* props after Panel's own domain
 * props are destructured — critically, `width` and `zIndex` are Panel domain
 * props whose names also appear in `STYLED_SYSTEM_PROPS`. Gating on the full
 * prop object would push almost every real Panel usage (anything setting
 * `width`) onto the styled path and defeat the migration, so we exclude the
 * domain props first and gate only on `rest`.
 */
export const PanelHybrid = (props: TypePanelProps) => {
  const {
    children,
    closeButtonLabel,
    header,
    headerless,
    footer,
    title,
    titleId,
    direction,
    width,
    gap,
    mobileBreakpoint,
    zIndex,
    id,
    snapPoints,
    defaultSnapPoint,
    snapPoint,
    onSnapPointChange,
    snapToSequentialPoints,
    actions,
    actionsInHeader,
    "aria-labelledby": ariaLabelledBy,
    "aria-label": ariaLabel,
    ...rest
  } = props;

  if (needsStyledComponents(rest)) {
    return <PanelStyled {...props} />;
  }

  return <PanelTailwind {...props} />;
};

PanelHybrid.displayName = "Panel";
